export type PhotoCropPosition = { zoom: number; x: number; y: number };

/** Pan is measured in viewport widths, so the same crop works at every preview size. */
export function photoCrop(
  width: number,
  height: number,
  position: PhotoCropPosition,
  fit: "cover" | "contain" = "cover",
) {
  if (![width, height].every((value) => Number.isFinite(value) && value > 0))
    throw new RangeError("Invalid image dimensions");
  const zoom = Number.isFinite(position.zoom)
    ? Math.max(fit === "contain" ? 0.5 : 1, Math.min(4, position.zoom))
    : 1;
  const size = (fit === "contain" ? Math.max(width, height) : Math.min(width, height)) / zoom;
  const limit = (value: number, maximum: number) =>
    Math.max(-maximum, Math.min(maximum, Number.isFinite(value) ? value : 0));
  const x = limit(position.x, Math.abs(width / size - 1) / 2);
  const y = limit(position.y, Math.abs(height / size - 1) / 2);
  return {
    zoom,
    x,
    y,
    size,
    left: (width - size) / 2 - x * size,
    top: (height - size) / 2 - y * size,
  };
}
